import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfileImage from '../../profileImage';

const TeamOverview = ({ teamMembers, selectedChild, teamData, startChat }) => {
  const navigate = useNavigate();

  const chatWithOrganization = () => {
    // Navigate to chat with organization
    navigate('/chat');
  };

  return (
    <div className="space-y-6">
      {/* Organization Chat Button */}
      {teamData?.organization && (
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-xl p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {teamData.organization.logo && (
                <img
                  src={teamData.organization.logo}
                  alt={teamData.organization.name}
                  className="w-16 h-16 rounded-lg object-cover"
                />
              )}
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  {teamData.organization.name}
                </h3>
                <p className="text-sm text-gray-600">Organization</p>
                <p className="text-xs text-gray-500 mt-1">
                  Connect with the organization management
                </p>
              </div>
            </div>
            <button
              onClick={chatWithOrganization}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 hover:shadow-md transition-all duration-300 text-sm flex items-center space-x-2"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
              </svg>
              <span>Chat with Organization</span>
            </button>
          </div>
        </div>
      )}

      {/* Team Members List */}
      <div>
        <h3 className="text-xl font-semibold mb-6">Team Members</h3>
        {teamMembers.length === 0 ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3z"/>
              </svg>
            </div>
            <h4 className="text-lg font-medium text-gray-900 mb-2">No Team Members</h4>
            <p className="text-gray-500">Team members will appear here when available</p>
          </div>
        ) : (
          <div className="space-y-4">
            {teamMembers.map((member) => (
              <div key={member._id} className="bg-gradient-to-r from-orange-50 to-white border border-orange-200 rounded-xl p-6 hover:shadow-md transition-all duration-300">
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-4">
                    <div className="relative">
                      <ProfileImage
                        image={member.profilePicture}
                        alt={member.userName}
                        className="w-16 h-16 rounded-full object-cover"
                      />
                      {member.isOnline && (
                        <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-green-500 border-2 border-white rounded-full"></div>
                      )}
                      {member.jerseyNumber && (
                        <div className="absolute -top-1 -left-1 w-6 h-6 text-white text-xs font-bold rounded-full flex items-center justify-center" style={{backgroundColor: '#e25820'}}>
                          {member.jerseyNumber}
                        </div>
                      )}
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 mb-1">
                        <h4 className="font-semibold text-gray-900">
                          @{member.userName}
                        </h4>
                        <span className={`inline-flex px-2 py-1 rounded-full text-xs font-medium ${
                          member.accountType === 'supervisor' 
                            ? 'bg-purple-100 text-purple-800' 
                            : 'bg-orange-100 text-orange-800'
                        }`}>
                          {member.accountType}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 font-medium mb-2">
                        {member.position || (member.accountType === 'supervisor' ? 'Staff' : 'Player')}
                      </p>
                      {member.title && (
                        <p className="text-sm text-gray-500 mb-1">
                          {member.title}
                        </p>
                      )}
                      <div className="flex items-center space-x-1 mt-2">
                        <span className="text-xs text-gray-400">
                          Joined {new Date(member.joinDate).toLocaleDateString()}
                        </span>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex space-x-2">
                    <button
                      onClick={() => startChat(member)}
                      className="px-4 py-2 text-white rounded-lg hover:shadow-md transition-all duration-300 text-sm flex items-center space-x-2"
                      style={{backgroundColor: '#e25820'}}
                      onMouseEnter={(e) => e.target.style.backgroundColor = '#d14d1a'}
                      onMouseLeave={(e) => e.target.style.backgroundColor = '#e25820'}
                    >
                      <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z"/>
                      </svg>
                      <span>Chat</span>
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamOverview; 